import { App } from "@capacitor/app";
import { IonButton, IonContent, IonIcon } from "@ionic/react";
import { t } from "i18next";
import { timerOutline } from "ionicons/icons";
import React, { useCallback, useEffect } from "react";
import { debug } from "../App";
import { PageHeader } from "../components/PageHeader";
import BasicTemplate from "../components/PageTemplates/BasicTemplate";
import { ApiService } from "../services";

export const Pending = (props: any) => {
  const check = useCallback(() => {
    ApiService.get("members/me").then(({ status }) => {
      debug("Member status = " + status);

      if (status === "approved") {
        window.location.reload();
      }
    });
  }, []);

  App.addListener("resume", () => {
    debug("App resumed, checking pending status...");
    check();
  });

  useEffect(() => {
    const interval = setInterval(() => {
      check();
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [check]);

  return (
    <BasicTemplate hideHeader={true} hideBackButton={true} title={t(props.status)}>
      <IonContent className={"ion-padding"} fullscreen={true}>
        <div className={"ion-padding-safe-area-top"}>
          <IonIcon size={"large"} icon={timerOutline} />

          <PageHeader>{t(props.status)}</PageHeader>
          <p>{t(props.status + "Message")}</p>
          <p>{t("pendingMessageAuto")}</p>

          <IonButton routerLink={"/sign-out"}>{t("signOut")}</IonButton>
        </div>
      </IonContent>
    </BasicTemplate>
  );
};
